import React, { useEffect, useState } from "react";
import { FiX } from "react-icons/fi"; // Feather Icons X

const Modal = ({ isOpen, onClose, service }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isOpen && service) {
      setShow(true);
      document.body.style.overflow = 'hidden';
    } else {
      setShow(false);
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen, service]);

  if (!isOpen || !service) return null;

  return (
    <div className={`fixed inset-0 z-50 flex items-center justify-center px-4 transition-opacity duration-300 ${show ? 'bg-black bg-opacity-70 opacity-100' : 'opacity-0'}`}>
      <div className={`bg-white max-w-4xl w-full grid grid-cols-1 md:grid-cols-2 rounded shadow-lg relative overflow-hidden transform transition-all duration-300 ${show ? 'scale-100 opacity-100' : 'scale-95 opacity-0'}`}>
        {/* Image */}
        <img
          src={service.image}
          alt={service.title}
          className="w-full h-full object-cover"
        />

        {/* Content */}
        <div className="p-10 bg-[#EDF2FA] flex flex-col h-full justify-between relative min-h-[340px]">
          {/* Close button using react-icons */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-700 hover:text-black"
          >
            <FiX size={24} />
          </button>

          <div className="flex-1 flex flex-col justify-between">
            <div>
              <h3 className="text-xl font-bold text-[#003A7D] uppercase mb-4 text-left">
                {service.title}
              </h3>
              <p className="text-sm text-gray-700 mb-6 text-left">{service.description}</p>
            </div>
            <a
              href="/contact"
              className="bg-[#003A7D] text-white px-4 py-2 text-sm font-semibold rounded hover:bg-blue-900 self-center mt-4 text-center block"
              onClick={onClose}
            >
              CONTACT US
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
